import { login } from '../../api/auth'
import { resetRouter } from '../../router'

// 从 localStorage 恢复用户信息
const getUserInfo = () => {
  try {
    const userInfo = localStorage.getItem('userInfo')
    return userInfo ? JSON.parse(userInfo) : null
  } catch (e) {
    return null
  }
}

const userInfo = getUserInfo()

const state = {
  token: localStorage.getItem('token') || '',
  user: userInfo?.user || null,
  roles: userInfo?.roles || [],
  departments: userInfo?.departments || [],
  stations: userInfo?.stations || [],
  menus: userInfo?.menus || [],
  avatar: ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    localStorage.setItem('token', token)
  },
  SET_USER_INFO: (state, data) => {
    // 保存用户信息
    state.user = data.user || null
    state.roles = data.roles || []
    state.departments = data.departments || []
    state.stations = data.stations || []
    state.menus = data.menus || []
    
    // 保存到 localStorage
    const userInfo = {
      user: state.user,
      roles: state.roles,
      departments: state.departments,
      stations: state.stations,
      menus: state.menus
    }
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  CLEAR_USER_INFO: (state) => {
    state.user = null
    state.roles = []
    state.departments = []
    state.stations = []
    state.menus = []
    localStorage.removeItem('userInfo')
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  }
}

const getters = {
  // 显示名称：优先显示昵称，没有则显示用户名
  name: state => {
    if (state.user) {
      return state.user.nickname || state.user.username || '未登录'
    }
    return '未登录'
  },
  // 用户名
  username: state => state.user?.username || '',
  // 昵称
  nickname: state => state.user?.nickname || '',
  // 用户信息
  user: state => state.user,
  // 角色列表
  roles: state => state.roles,
  // 部门列表
  departments: state => state.departments,
  // 岗位列表
  stations: state => state.stations,
  // 菜单列表
  menus: state => state.menus,
  // 头像
  avatar: state => state.avatar,
  // Token
  token: state => state.token,
  // 用户ID
  userId: state => state.user?.id || null
}

const actions = {
  // 用户登录
  login({ commit }, loginInfo) {
    const { username, password } = loginInfo
    return new Promise((resolve, reject) => {
      login(username.trim(), password)
        .then(response => {
          const { data } = response
          
          // 保存 token
          commit('SET_TOKEN', data.token)
          
          // 保存完整的用户信息（用户、角色、部门、岗位、菜单）
          commit('SET_USER_INFO', {
            user: data.user,
            roles: data.roles || [],
            departments: data.departments || [],
            stations: data.stations || [],
            menus: data.menus || []
          })
          
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 用户登出
  logout({ commit, dispatch }) {
    commit('SET_TOKEN', '')
    commit('CLEAR_USER_INFO')
    localStorage.removeItem('token')
    dispatch('permission/resetRoutes', null, { root: true })
    dispatch('approval/clearTodoCounts', null, { root: true })
    resetRouter()
  },

  // 移除token
  resetToken({ commit, dispatch }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('CLEAR_USER_INFO')
      localStorage.removeItem('token')
      dispatch('permission/resetRoutes', null, { root: true })
      dispatch('approval/clearTodoCounts', null, { root: true })
      resetRouter()
      resolve()
    })
  },

  // 更新用户信息（用于编辑用户信息后更新）
  updateUserInfo({ commit, state }, userInfo) {
    if (state.user && state.user.id === userInfo.id) {
      commit('SET_USER_INFO', {
        user: { ...state.user, ...userInfo },
        roles: state.roles,
        departments: state.departments,
        stations: state.stations,
        menus: state.menus
      })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}